import { render, staticRenderFns } from "./Tennis.vue?vue&type=template&id=2030ee7c&scoped=true&"
import script from "./Tennis.vue?vue&type=script&lang=js&"
export * from "./Tennis.vue?vue&type=script&lang=js&"
import style0 from "./Tennis.vue?vue&type=style&index=0&id=2030ee7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030ee7c",
  null
  
)

export default component.exports